module.exports = __webpack_public_path__ + "static/img/ximiko_dialyma.e1cf62c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tools/ximiko_dialyma.png
// module id = 462
// module chunks = 1